import React, { useState, useEffect } from "react";
// Components
import TablaUsuarios from "./TablaUsuarios";
import ModalNuevoUsuario from "./NuevoUsuario";
import ModalEditarUsuario from "./EditarUsuario";
import ModalBorrarUsuario from "./BorrarUsuario";
// Material-UI
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
// Icons
import { CirclePlus, Edit, CircleX } from 'tabler-icons-react';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
// Context
import { useUsuarios, UsuariosProvider } from "./UsuariosContext";
// Styles
import '../../styles/usuarios.css';

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

function Usuarios() {
  const { selectionModel, usuarios } = useUsuarios();
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [rows, setRows] = useState([]);

  useEffect(() => { setRows(usuarios); }, [usuarios]);

  const requestSearch = (value) => {
    setSearchText(value);
    if (!value) { setRows(usuarios); return; }
    const re = new RegExp(escapeRegExp(value), 'i');
    setRows(usuarios.filter(row =>
      Object.keys(row).some(f => row[f] !== null && re.test(row[f].toString()))
    ));
  };

  const hasSelection = selectionModel.length > 0;
  const hasSingle = selectionModel.length === 1;

  return (
    <div className="usuarios-view">
      <div className="usuarios-header">
        <h1 className="usuarios-title">Usuarios</h1>
        <p className="usuarios-desc">
          Especifica el nombre y usuario, contacto y roles.
          Permite crear, editar y deshabilitar usuarios.
        </p>
      </div>

      <div className="usuarios-table-card">
        <div className="usuarios-card-toolbar">
          <span className="usuarios-selected-count">{selectionModel.length} seleccionados</span>

          <TextField
            variant="outlined"
            size="small"
            value={searchText}
            onChange={e => requestSearch(e.target.value)}
            placeholder="Buscar..."
            className="table-search-inline"
            InputProps={{
              startAdornment: <SearchIcon fontSize="small" />,
              endAdornment: (
                <IconButton
                  size="small"
                  className={searchText ? 'table-search-clear-visible' : 'table-search-clear-hidden'}
                  onClick={() => requestSearch('')}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ),
            }}
          />

          <div className="usuarios-card-actions">
            <Button variant="text" className="usuarios-toolbar-btn" onClick={() => setAddOpen(true)}>
              <CirclePlus size={16} strokeWidth={2} /> Nuevo
            </Button>
            <Button variant="text" className="usuarios-toolbar-btn" disabled={!hasSingle} onClick={() => setEditOpen(true)}>
              <Edit size={16} strokeWidth={2} /> Editar
            </Button>
            <Button variant="text" className="usuarios-toolbar-btn usuarios-toolbar-btn--danger" disabled={!hasSelection} onClick={() => setDeleteOpen(true)}>
              <CircleX size={16} strokeWidth={2} /> Deshabilitar
            </Button>
          </div>
        </div>

        <div className="usuarios-table-wrapper">
          <TablaUsuarios rows={rows} />
        </div>
      </div>

      <ModalNuevoUsuario open={addOpen} onClose={() => setAddOpen(false)} />
      <ModalEditarUsuario open={editOpen} onClose={() => setEditOpen(false)} />
      <ModalBorrarUsuario open={deleteOpen} onClose={() => setDeleteOpen(false)} />
    </div>
  );
}

const UsuariosPage = () => (
  <UsuariosProvider>
    <Usuarios />
  </UsuariosProvider>
);

export default UsuariosPage;
